import { useState, useEffect, useCallback } from "react";

const useSubscriptionUpgrade = () => {
  const [currentSubscription, setCurrentSubscription] = useState(null);
  const [upgradePackages, setUpgradePackages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchCurrentSubscription = async () => {
    try {
      const response = await fetch(`https://urchin-app-vijhz-lvk4i.ondigitalocean.app/api/v1/organization/subscription/packages/my-subscription`, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`,
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error('Failed to fetch current subscription');
      }

      const data = await response.json();
      return data;
    } catch (err) {
      throw new Error(err.message);
    }
  };

  const fetchUpgradePackages = async () => {
    try {
      const response = await fetch(`https://urchin-app-vijhz-lvk4i.ondigitalocean.app/api/v1/organization/subscription/packages/with-defrance`, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`,
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        // If user doesn't have subscription or other error, return empty array
        if (response.status === 404) {
          return [];
        }
        throw new Error('Failed to fetch upgrade packages');
      }

      const data = await response.json();
      return data;
    } catch (err) {
      throw new Error(err.message);
    }
  };

  const fetchData = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      
      const [subscription, packages] = await Promise.all([
        fetchCurrentSubscription(),
        fetchUpgradePackages()
      ]);
      
      setCurrentSubscription(subscription);
      setUpgradePackages(packages);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const refetch = () => {
    fetchData();
  };

  return {
    currentSubscription,
    upgradePackages,
    loading,
    error,
    refetch
  };
};

export default useSubscriptionUpgrade; 